

















































































import {Component, Vue, Prop, Emit, Watch} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {権限レベル区分型} from '@/type/authentication/login';
import DatePicker from '@/components/datepicker/DatePicker.vue';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import {progress} from '@/script/progress';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {loginModule} from '@/store/authentication/login';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import {利用者初期値, 利用者型} from '@/type/user/user';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';

@Component({
  components: {
    DatePicker,
    DepartmentSelector,
    ConfirmDialog,
    NormalButton,
    NormalDialog,
    AlertDialog,
  },
})

export default class UpdateUser extends Vue {

  @Prop({default: false})
  private modal!: boolean;
  @Prop({default: 利用者初期値})
  private user!: 利用者型;

  private 利用者更新: 利用者型 = {...this.user};
  private 権限レベル区分リスト: string[] = [
    権限レベル区分型.管理者,
    権限レベル区分型.利用者,
  ];
  private アラートメッセージ: string[] = [];

  @Watch('modal')
  private changeDialog(nowModal: boolean, prevModal: boolean): void {
    if (nowModal) {
      this.利用者更新 = {...this.user};
      this.openDialog('ログインマスタ更新画面');
    }
  }

  @Emit('close-form')
  private closeForm(): void {
    this.clear();
    this.closeDialog('ログインマスタ更新画面');
  }

  private openDialog(name: string): void {
    this.$modal.show(name);
  }

  private closeDialog(name: string): void {
    this.$modal.hide(name);
  }

  private updateHandler(): void {
    progress(this.update);
  }

  private async update(): Promise<void> {
    if (this.利用者更新) {
      await api.利用者を更新する(this.利用者更新)
        .then(
          () => {
            this.closeDialog('確定ダイアログ');
            this.closeForm();
          },
          (error: any) => {
            this.closeDialog('確定ダイアログ');
            if (error.data.errors) {
              this.アラートメッセージ = error.data.errors;
            }
            if (error.data.message && !error.data.errors) {
              this.アラートメッセージ = [error.data.message];
            }
            this.openDialog('利用者更新アラート');
          },
        );
    }
  }

  private get isLoginUser(): boolean {
    if (this.user === null) {
      return false;
    }
    return this.user.利用者コード === loginModule.利用者コードを取得する;
  }

  private clear(): void {
    this.init();
    this.closeDialog('クリアダイアログ');
  }

  private init(): void {
    this.利用者更新 = {...this.user};
    this.アラートメッセージ = [];
  }

  private get isAdmin(): boolean {
    return loginModule.管理者である;
  }

  private get isDeleted(): boolean {
    if (this.user === null) {
      return false;
    }
    return this.user.削除フラグ === '削除';
  }
}
